/**
 * inCust Corporate Off-line Site API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Settings {
  application_settings?: object;
  /**
   * Site ID
   */
  id?: string;
  /**
   * Site title
   */
  title?: string;
}
